import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, toDisplayString as _toDisplayString, Fragment as _Fragment } from "vue";
import _imports_0 from '../assets/benefits.png';
const _hoisted_1 = {
    key: 0,
    class: "simplePage",
    style: { "margin-top": "-40px" }
};
const _hoisted_2 = { key: 0 };
const _hoisted_3 = { key: 1 };
const _hoisted_4 = {
    key: 2,
    class: "amount"
};
const _hoisted_5 = { class: "anchor-bottom" };
import { ref, onMounted } from 'vue';
import { useAppState } from '@/composables/useAppState';
import { useAuth } from '@/composables/useAuth';
import { useCustomer } from '@/composables/useCustomer';
import { useContent } from '@/composables/useContent';
import { useApi } from '@/composables/useApi';
import { getHttpInstance, getApiConfig } from '@/composables/useApi';
import HeaderBlock from './elements/HeaderBlock.vue';
import CustomerLoadWait from './elements/CustomerLoadWait.vue';
import MGButton from './elements/MGButton.vue';
export default /*@__PURE__*/ _defineComponent({
    __name: 'BenefitsCalculatorResultsPage',
    setup(__props) {
        const state = useAppState();
        useAuth();
        const { getCustomer } = useCustomer();
        const { getBenefits } = useContent();
        const api = useApi();
        const benefits = ref(null);
        function getQuestionnaireByKey(key, onSuccess = null) {
            getHttpInstance().post(getApiConfig().api + "/Questionnaires/Searches/" + key, null)
                .then((response) => {
                if (onSuccess)
                    onSuccess(response.data);
            })
                .catch((result) => {
                if (result.response && result.response.status == 401) {
                    api.refreshLogin(() => getQuestionnaireByKey(key, onSuccess));
                }
            });
        }
        function getQuestionnaireAnswers(onSuccess = null) {
            api.GET("/Customers/00000000-0000-0000-0000-000000000000/CustomerAnswers", (result) => {
                state.questionnaireAnswers = result;
                if (onSuccess)
                    onSuccess(result);
            }, false);
        }
        function buildBenefitsRequest(answers, questionnaire, customer) {
            const benefitsRequest = {
                relationshipStatus: '',
                dob: customer.person.dob.split('T')[0],
                childrenNum: 0,
                housingType: 0,
                postcode: '',
                monthlyIncomeAmount: 0,
                monthlyBenefitsAmount: 0
            };
            const latestAnswers = answers.filter((a) => a.isLatest);
            latestAnswers.forEach((answer) => {
                const question = questionnaire.questionnaireQuestions.find((q) => q.question.key === answer.question.key);
                if (question) {
                    const questionKey = question.question.key;
                    const cleanQuestionKey = questionKey.split('_')[0];
                    switch (cleanQuestionKey) {
                        case 'LiveWithPartner':
                            if (answer.answer) {
                                benefitsRequest.relationshipStatus = answer.answer.value;
                            }
                            break;
                        case 'CHILDREN':
                            if (answer.freeAnswer) {
                                benefitsRequest.childrenNum = answer.freeAnswer;
                            }
                            break;
                        case 'HOUSINGS':
                            if (answer.freeAnswer) {
                                benefitsRequest.housingType = answer.freeAnswer;
                            }
                            break;
                        case 'Postcode':
                            if (answer.freeAnswer) {
                                benefitsRequest.postcode = answer.freeAnswer;
                            }
                            break;
                        case 'HOUSEHOL':
                            if (answer.freeAnswer) {
                                benefitsRequest.monthlyIncomeAmount = parseFloat(answer.freeAnswer) || 0;
                            }
                            break;
                    }
                }
            });
            return benefitsRequest;
        }
        function openInBest() {
            if (benefits.value && benefits.value.benefitsCalculatorLink) {
                window.open(benefits.value.benefitsCalculatorLink, '_blank');
            }
        }
        function onLoad() {
            getCustomer(() => {
                getQuestionnaireByKey('InBest', (q) => {
                    console.log(q, 'Questionnaire');
                    getQuestionnaireAnswers((answers) => {
                        console.log(answers, 'all customer Answers');
                        const benefitsRequest = buildBenefitsRequest(answers, q, state.customer);
                        console.log(benefitsRequest, 'Benefits Request');
                        getBenefits((result) => {
                            benefits.value = result;
                            console.log(result, 'Benefits');
                        }, benefitsRequest);
                    });
                });
            });
        }
        onMounted(() => {
            onLoad();
        });
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock(_Fragment, null, [
                _createVNode(HeaderBlock, {
                    bgcolor: "#00000000",
                    border: "0"
                }),
                _createVNode(CustomerLoadWait, {
                    customer: benefits.value,
                    cardBlocks: true
                }, null, 8, ["customer"]),
                (benefits.value)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                        _cache[0] || (_cache[0] = _createElementVNode("img", { src: _imports_0 }, null, -1)),
                        (benefits.value.monthlyBenefitsAmount > 0)
                            ? (_openBlock(), _createElementBlock("h1", _hoisted_2, "You may be entitled to"))
                            : (_openBlock(), _createElementBlock("h1", _hoisted_3, "It doesn't appear you're eligible, but you may still want to complete a full application to be certain")),
                        (benefits.value.monthlyBenefitsAmount > 0)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(_unref(state).formatter.format(benefits.value.monthlyBenefitsAmount)) + " per month.", 1))
                            : _createCommentVNode("", true),
                        _cache[1] || (_cache[1] = _createElementVNode("p", null, "Use the InBest free benefits calculator to find out your exact benefit entitlement. It should take less than 5 minutes to complete! ", -1)),
                        _createElementVNode("div", _hoisted_5, [
                            _createVNode(MGButton, {
                                text: "Start",
                                arrow: "",
                                onClick: openInBest
                            })
                        ])
                    ]))
                    : _createCommentVNode("", true)
            ], 64));
        };
    }
});
